import type { MessageKey } from "./en";

export const ar: Record<MessageKey, string> = {
  "brand.name": "سوريا في ٣ ساعات",

  "common.loading": "جارٍ التحميل",
  "common.loadFailed": "تعذّر تحميل هذه الصفحة",
  "common.actionFailed": "لم ينجح ذلك. حاول مرة أخرى.",
  "common.actions": "إجراءات",
  "common.cancel": "إلغاء",
  "common.close": "إغلاق",
  "common.discard": "تجاهل التغييرات",
  "common.optional": "(اختياري)",

  "roles.admin": "مدير",
  "roles.editor": "محرر",

  "shell.navLabel": "التنقل الرئيسي",
  "shell.markLabel": "شعار سوريا في ٣ ساعات، ونافذة الساعات الثلاث الحالية مملوءة على الساعة",
  "shell.damascusTime": "{time} بتوقيت دمشق",
  "shell.switchLanguage": "تغيير اللغة",
  "shell.darkMode": "استخدام الوضع الداكن",
  "shell.lightMode": "استخدام الوضع الفاتح",
  "shell.signOut": "تسجيل الخروج",
  "shell.openMenu": "فتح القائمة",

  "nav.groupNewsroom": "غرفة الأخبار",
  "nav.groupPipeline": "سلسلة العمل",
  "nav.overview": "اليوم",
  "nav.review": "قائمة المراجعة",
  "nav.publishLog": "سجل النشر",
  "nav.telegram": "مصادر تيليغرام",
  "nav.ai": "إعدادات الذكاء الاصطناعي",
  "nav.schedules": "الجداول الزمنية",
  "nav.platforms": "منصات النشر",
  "nav.notifications": "التنبيهات",

  "login.subtitle": "سجّل الدخول لمراجعة أحدث الملخصات ونشرها.",
  "login.username": "اسم المستخدم",
  "login.password": "كلمة المرور",
  "login.submit": "تسجيل الدخول",
  "login.failed": "تعذّر تسجيل الدخول. تحقق من اسم المستخدم وكلمة المرور.",

  "notFound.title": "لا توجد صفحة هنا",
  "notFound.body": "ربما الرابط قديم أو نُقلت الصفحة.",
  "notFound.back": "الانتقال إلى ملخص اليوم",

  "status.draft": "مسودة",
  "status.approved": "معتمد",
  "status.rejected": "مرفوض",
  "status.published": "منشور",
  "status.queued": "في الانتظار",
  "status.sent": "أُرسل",
  "status.failed": "فشل",
  "status.manual": "يُنشر يدوياً",
  "status.running": "قيد التنفيذ",
  "status.succeeded": "اكتمل",
  "status.empty": "لا أخبار",
  "status.skipped": "تم تخطيه",
  "status.pending_code": "بانتظار الرمز",
  "status.pending_password": "بانتظار كلمة المرور",
  "status.active": "مسجّل الدخول",
  "status.revoked": "خرج من الحساب",
  "status.critical": "حرج",
  "status.warning": "تحذير",
  "status.info": "معلومة",
  "status.flagged": "مُعلَّم",

  "overview.writtenBy": "يكتب الملخصاتِ النموذجُ",
  "overview.autoApproveOn": "الاعتماد التلقائي مفعّل للملخصات غير المعلَّمة",
  "overview.autoApproveOff": "كل ملخص ينتظر مراجعة محرر",
  "overview.windows": "نوافذ اليوم",
  "overview.inProgress": "جارٍ الجمع",
  "overview.upcoming": "لاحقاً اليوم",
  "overview.noRun": "لا ملخص",
  "overview.quietWindow": "لم تصل رسائل جديدة في هذه النافذة.",
  "overview.runFailed": "فشل إعداد الملخص.",
  "overview.messagesFolded": "الرسائل: {n}، المكررات المدموجة: {d}",
  "overview.draftsWaiting": "مسودات للمراجعة",
  "overview.flaggedNote": "علّمها النموذج: {n}",
  "overview.approvedWaiting": "معتمدة ولم تُنشر بعد",
  "overview.publishFailures": "منشورات فاشلة خلال ٢٤ ساعة",
  "overview.messagesToday": "رسائل اليوم",
  "overview.foldedNote": "المكررات المدموجة: {n}",
  "overview.spend": "إنفاق الذكاء الاصطناعي هذا الشهر",
  "overview.ofBudget": "من ميزانية {budget}",
  "overview.viewAlert": "عرض التنبيه",
  "overview.emailFailingTitle": "رسائل التنبيه لا تصل",
  "overview.emailFailingBody":
    "تنبيهات حرجة تعذّر إرسالها بالبريد هذا الأسبوع: {n}. راجع إعدادات خادم البريد في صفحة التنبيهات.",
  "overview.waiting": "بانتظار المراجعة",
  "overview.openQueue": "فتح قائمة المراجعة",
  "overview.queueEmpty": "لا شيء للمراجعة الآن.",
  "overview.listener": "مستمع تيليغرام",
  "overview.noAccounts": "لا يوجد حساب تيليغرام مسجّل، لذلك لا تصل أي رسائل.",
  "overview.addAccount": "إضافة حساب",
  "overview.listening": "يستمع الآن",
  "overview.lastSeen": "آخر اتصال {when}",
  "overview.neverConnected": "لم يتصل بعد",
  "overview.channelsActive": "القنوات المقروءة: {n}. الرسائل خلال آخر ٣ ساعات: {m}.",

  "review.title": "قائمة المراجعة",
  "review.description": "قارن كل مسودة بمصادرها، وصحّح الصياغة، ثم اعتمدها أو انشرها.",
  "review.filterLabel": "عرض الملخصات",
  "review.filterDraft": "للمراجعة",
  "review.filterFlagged": "المعلَّمة",
  "review.filterAll": "الكل",
  "review.search": "البحث في العناوين والنصوص",
  "review.flagged": "علّمه النموذج",
  "review.sourcesCount": "المصادر: {n}",
  "review.foldedCount": "المكررات المدموجة: {n}",
  "review.digest": "الحصاد اليومي",
  "review.digestOf": "حصاد {date}",
  "review.emptyDraftsTitle": "لا مسودات بانتظارك",
  "review.emptyDraftsBody": "تظهر المسودات الجديدة هنا بعد كل دورة من ثلاث ساعات.",
  "review.emptyTitle": "لا ملخصات مطابقة",
  "review.emptyBody": "جرّب تصفية أخرى أو امسح البحث.",
  "review.pickOne": "اختر ملخصاً من القائمة.",
  "review.backToQueue": "العودة إلى القائمة",
  "review.sourcesButton": "المصادر ({n})",
  "review.flaggedTitle": "علّم النموذج هذا الملخص",
  "review.rejectedBecause": "مرفوض",
  "review.headline": "العنوان",
  "review.body": "الملخص",
  "review.bullets": "النقاط الرئيسية",
  "review.bulletsHint": "نقطة في كل سطر",
  "review.saveChanges": "حفظ التغييرات",
  "review.saved": "حُفظت التغييرات، وتُعاد رسم الصورة.",
  "review.approve": "اعتماد",
  "review.approvedToast": "اعتُمد، وسيُنشر في دورة النشر التالية.",
  "review.publishNow": "انشر الآن",
  "review.publishingToast": "جارٍ النشر على كل المنصات المفعّلة.",
  "review.edit": "تحرير",
  "review.reopen": "إعادة إلى المسودات",
  "review.reopenedToast": "أُعيد إلى المسودات.",
  "review.reject": "رفض",
  "review.rejectTitle": "رفض هذا الملخص؟",
  "review.rejectDescription": "لن يُنشر. يمكنك إعادته إلى المسودات لاحقاً.",
  "review.reason": "السبب",
  "review.rejectedToast": "رُفض.",
  "review.imageVariant": "مقاس الصورة",
  "review.regenerateImage": "إعادة رسم الصورة",
  "review.imageRegenerated": "أُعيد رسم الصورة.",
  "review.imageAlt": "صورة بطاقة الملخص",
  "review.imagePending": "ما زالت الصورة قيد الرسم",
  "review.sourcesTitle": "الرسائل المصدر",
  "review.sourcesDescription":
    "ما قرأه النموذج لكتابة هذا الملخص. المكررات من قنوات أخرى مطوية في الأسفل.",
  "review.translatedFrom": "مترجم من {lang}",
  "review.openInTelegram": "فتح في تيليغرام",
  "review.mediaOnly": "صورة أو فيديو بلا نص",
  "review.showDuplicates": "عرض المكررات المدموجة ({n})",
  "review.hideDuplicates": "إخفاء المكررات",
  "review.runDetails": "كيف كُتب",
  "review.model": "النموذج",
  "review.cost": "التكلفة",
  "review.tokens": "الرموز الداخلة / الخارجة",
  "review.latency": "المدة",
  "review.attempts": "المحاولات",
  "review.messagesIn": "الرسائل المقروءة",
  "review.publishing": "النشر",
  "review.notPublishedYet": "لم يُرسل إلى أي منصة بعد.",
  "review.viewPost": "عرض المنشور",
  "review.history": "السجل",

  "revision.created": "كتبه النموذج",
  "revision.edited": "عُدّل",
  "revision.approved": "اعتُمد",
  "revision.auto_approved": "اعتُمد تلقائياً",
  "revision.rejected": "رُفض",
  "revision.reopened": "أُعيد إلى المسودات",
  "revision.publish_requested": "طُلب النشر",
  "revision.published": "نُشر على كل المنصات",

  "dedup.": "الأصل",
  "dedup.forward": "نسخة محوّلة",
  "dedup.exact": "النص نفسه",
  "dedup.normalized": "النص نفسه بروابط أو رموز مختلفة",
  "dedup.simhash": "صياغة شبه مطابقة",

  "platform.telegram": "قناة تيليغرام",
  "platform.facebook": "صفحة فيسبوك",
  "platform.instagram": "إنستغرام",
  "platform.x": "إكس",
  "platform.whatsapp": "قناة واتساب",
  "platform.telegram.note": "ينشر الصورة والنص كاملاً عبر بوت",
  "platform.facebook.note": "منشور بصورة على صفحتك",
  "platform.instagram.note": "صورة مربعة مع تعليق، ويتطلب روابط صور عامة",
  "platform.x.note": "العنوان والصورة والرابط، ويتطلب اشتراكاً مدفوعاً في واجهة إكس",
  "platform.whatsapp.note": "لا توجد واجهة برمجية، انسخ الملخصات المعتمدة من صفحة التصدير",

  "platformField.bot_token": "رمز البوت",
  "platformField.chat_id": "القناة",
  "platformField.page_access_token": "رمز وصول الصفحة",
  "platformField.page_id": "معرّف الصفحة",
  "platformField.access_token": "رمز الوصول",
  "platformField.ig_user_id": "معرّف حساب إنستغرام التجاري",
  "platformField.api_key": "مفتاح الواجهة",
  "platformField.api_secret": "سرّ مفتاح الواجهة",
  "platformField.access_token_secret": "سرّ رمز الوصول",
  "platformField.link_url": "رابط يُضاف إلى كل منشور",
  "platformField.channel_url": "رابط القناة",
  "platformField.footer": "نص يُضاف إلى كل منشور",

  "telegram.title": "مصادر تيليغرام",
  "telegram.description":
    "تقرأ الحسابات المسجّلة القنوات العامة. تصل الرسائل الجديدة خلال ثوانٍ وتُدمج المكررات تلقائياً.",
  "telegram.accounts": "الحسابات",
  "telegram.accountsDescription":
    "استخدم رقماً مخصصاً لهذا الغرض، ولا تتجاوز نحو ٢٠ قناة لكل حساب تجنباً لقيود تيليغرام.",
  "telegram.addAccount": "إضافة حساب",
  "telegram.noAccountsTitle": "لا حسابات بعد",
  "telegram.noAccountsBody": "أضف رقم هاتف، وسيرسل تيليغرام إليه رمز دخول تُدخله هنا.",
  "telegram.listening": "يستمع",
  "telegram.notListening": "لا يستمع",
  "telegram.lastSeen": "آخر اتصال {when}",
  "telegram.channelCount": "القنوات: {n}",
  "telegram.finishSignIn": "إكمال تسجيل الدخول",
  "telegram.removeAccount": "إزالة الحساب",
  "telegram.removeTitle": "إزالة هذا الحساب؟",
  "telegram.removeDescription": "سيتوقف المستمع عن استخدامه. تبقى قنواته، ويتولاها حساب مسجّل آخر.",
  "telegram.removed": "أُزيل الحساب.",
  "telegram.signInTitle": "تسجيل دخول حساب تيليغرام",
  "telegram.signInDescription": "الأمر يشبه تسجيل الدخول إلى تيليغرام من جهاز جديد.",
  "telegram.steps": "خطوات تسجيل الدخول",
  "telegram.step.phone": "رقم الهاتف",
  "telegram.step.code": "رمز الدخول",
  "telegram.step.password": "كلمة مرور التحقق بخطوتين",
  "telegram.phone": "رقم الهاتف",
  "telegram.phoneHint": "بالصيغة الدولية، ويبدأ بـ +",
  "telegram.label": "الاسم",
  "telegram.labelHint": "للتمييز بين الحسابات، مثل: القارئ ١",
  "telegram.sendCode": "إرسال رمز الدخول",
  "telegram.code": "رمز الدخول",
  "telegram.notConfiguredTitle": "تيليغرام غير موصول بهذا الخادم بعد",
  "telegram.notConfiguredBody":
    "لا يمكن إرسال رمز الدخول قبل إضافة بيانات واجهة تيليغرام إلى الخادم. أنشئها من my.telegram.org ← API development tools، وضع TELEGRAM_API_ID وTELEGRAM_API_HASH في ملف ‎.env على الخادم، ثم أعد تشغيل خدمتي api وlistener.",
  "telegram.notSentYet": "لم يُرسل أي رمز دخول إلى {phone} بعد.",
  "telegram.codeVia.app":
    "أرسل تيليغرام الرمز داخل تطبيق تيليغرام وليس برسالة نصية. افتح تيليغرام على هاتف أو حاسوب مسجّل فيه الرقم {phone} وابحث عن رسالة من «Telegram».",
  "telegram.codeVia.sms": "أرسل تيليغرام الرمز برسالة نصية إلى {phone}.",
  "telegram.codeVia.call": "يتصل تيليغرام بالرقم {phone} ليقرأ الرمز.",
  "telegram.codeVia.flash_call":
    "سيرنّ تيليغرام على {phone} لحظة قصيرة. الرمز هو آخر أرقام الرقم المتصل.",
  "telegram.codeVia.missed_call":
    "سيرنّ تيليغرام على {phone} مرة واحدة. الرمز هو آخر أرقام الرقم المتصل.",
  "telegram.codeVia.email": "أرسل تيليغرام الرمز إلى بريد الدخول المسجّل في هذا الحساب.",
  "telegram.codeVia.fragment": "أرسل تيليغرام الرمز عبر Fragment لهذا الرقم المجهول.",
  "telegram.codeVia.unknown": "أرسل تيليغرام رمز دخول للرقم {phone}.",
  "telegram.resendVia.sms": "أرسله برسالة نصية بدلاً من ذلك",
  "telegram.resendVia.call": "اتصل بي وأخبرني الرمز",
  "telegram.resendVia.flash_call": "احصل على الرمز عبر مكالمة",
  "telegram.resendVia.missed_call": "احصل على الرمز عبر مكالمة",
  "telegram.resendVia.fragment": "أرسله عبر Fragment",
  "telegram.codeResent": "رمز جديد في الطريق.",
  "telegram.resendCode": "إرسال رمز جديد",
  "telegram.verify": "تسجيل الدخول",
  "telegram.password": "كلمة مرور التحقق بخطوتين",
  "telegram.passwordHint": "لهذا الحساب كلمة مرور سحابية. أدخلها لإكمال الدخول.",
  "telegram.signedIn": "سُجّل دخول {name}. يبدأ المستمع خلال دقيقة.",
  "telegram.channels": "القنوات",
  "telegram.channelsDescription":
    "القنوات العامة التي تُقرأ. الإضافة تنضم إلى القناة وتجلب منشوراتها الأخيرة.",
  "telegram.needAccount": "سجّل دخول حساب أولاً، فالقنوات تُقرأ من خلاله.",
  "telegram.channelUsername": "اسم مستخدم القناة أو رابطها",
  "telegram.lookUp": "بحث",
  "telegram.subscribers": "المشتركون: {n}",
  "telegram.alreadySubscribed": "موجودة في مصادرك",
  "telegram.readWith": "القراءة عبر",
  "telegram.anyAccount": "أي حساب",
  "telegram.subscribe": "إضافة القناة",
  "telegram.subscribed": "أُضيفت {title}، وتُجلب منشوراتها الأخيرة.",
  "telegram.noChannelsTitle": "لا قنوات بعد",
  "telegram.noChannelsBody": "ابحث عن قناة عامة باسمها @ أو رابط t.me لبدء جمع الأخبار.",
  "telegram.channel": "القناة",
  "telegram.messagesToday": "اليوم",
  "telegram.lastPost": "آخر منشور",
  "telegram.reading": "تُقرأ",
  "telegram.backfill": "جلب المنشورات الفائتة",
  "telegram.unsubscribe": "إزالة القناة",
  "telegram.unsubscribed": "أُزيلت {title}.",

  "ai.title": "إعدادات الذكاء الاصطناعي",
  "ai.description":
    "كل تغيير يحفظ نسخة جديدة، فتعرف ماذا تغيّر ومتى. الكتابة دائماً بالعربية الفصحى.",
  "ai.onThisPage": "في هذه الصفحة",
  "ai.nav.connection": "مفتاح OpenRouter",
  "ai.nav.model": "النموذج",
  "ai.nav.generation": "التوليد",
  "ai.nav.routing": "المزوّدون",
  "ai.nav.prompt": "التعليمات",
  "ai.nav.guidelines": "الإرشادات التحريرية",
  "ai.nav.automation": "الاعتماد والميزانية",
  "ai.nav.usage": "الإنفاق",
  "ai.nav.test": "تجربة",
  "ai.connection": "مفتاح OpenRouter",
  "ai.connectionDescription":
    "مفتاح واحد من OpenRouter يتيح كل النماذج. يُحفظ مشفّراً ولا يُعرض مرة أخرى.",
  "ai.keyStored": "المفتاح محفوظ",
  "ai.noKey": "لا مفتاح محفوظ. لن تُكتب الملخصات حتى تضيف مفتاحاً.",
  "ai.apiKey": "مفتاح الواجهة",
  "ai.replaceKey": "استبدال المفتاح",
  "ai.keyHint": "أنشئ مفتاحاً من openrouter.ai/keys.",
  "ai.saveKey": "حفظ المفتاح",
  "ai.checkKey": "فحص المفتاح والرصيد",
  "ai.removeKey": "إزالة المفتاح",
  "ai.keySaved": "حُفظ المفتاح.",
  "ai.keyRemoved": "أُزيل المفتاح. تتوقف الملخصات حتى يُحفظ مفتاح جديد.",
  "ai.keyValid": "قبل OpenRouter المفتاح",
  "ai.keyInvalid": "رفض OpenRouter المفتاح",
  "ai.balance": "الرصيد المتبقي",
  "ai.keyLimit": "حد إنفاق المفتاح",
  "ai.keyUsage": "المُنفق بهذا المفتاح",
  "ai.modelTitle": "النموذج",
  "ai.modelDescription":
    "النموذج الأساسي يكتب كل الملخصات. إن تعطّل أو بلغ حد الطلبات، ينتقل OpenRouter إلى البدائل بالترتيب.",
  "ai.missingModels": "هذه النماذج لم تعد متاحة على OpenRouter. اختر بدائل لها.",
  "ai.primaryModel": "النموذج الأساسي",
  "ai.fallbacks": "النماذج البديلة",
  "ai.noFallbacks": "لا بدائل. أي عطل لدى المزوّد يوقف الدورة.",
  "ai.fallbacksHint": "اختر بدائل من شركات مختلفة كي لا يُسقطها عطل واحد كلها.",
  "ai.moveUp": "نقل للأعلى",
  "ai.moveDown": "نقل للأسفل",
  "ai.removeFallback": "إزالة البديل",
  "ai.searchModels": "البحث في النماذج",
  "ai.minContext": "السياق لا يقل عن",
  "ai.any": "أي حجم",
  "ai.refreshList": "تحديث القائمة",
  "ai.catalogRefreshed": "حُدّثت قائمة النماذج. عدد النماذج: {n}.",
  "ai.model": "النموذج",
  "ai.context": "السياق",
  "ai.priceIn": "الإدخال لكل مليون",
  "ai.priceOut": "الإخراج لكل مليون",
  "ai.primary": "أساسي",
  "ai.use": "استخدام",
  "ai.isFallback": "بديل",
  "ai.addFallbackFor": "إضافة {model} نموذجاً بديلاً",
  "ai.noModels": "لا نماذج مطابقة.",
  "ai.catalogMeta": "النماذج: {n}. حُدّثت القائمة {when}.",
  "ai.generation": "التوليد",
  "ai.generationDescription": "الحرارة المنخفضة تُبقي الملخصات قريبة من المصادر.",
  "ai.temperature": "الحرارة",
  "ai.temperatureHint": "القيم بين ٠٫٢ و٠٫٤ تناسب الأخبار. القيم الأعلى تزيد التنويع والمخاطرة.",
  "ai.maxTokens": "أطول رد",
  "ai.maxTokensHint": "بالرموز. يحتاج الملخص عادةً بين ٦٠٠ و١٢٠٠.",
  "ai.topP": "Top P",
  "ai.routing": "المزوّدون",
  "ai.routingDescription": "حدّد الشركات التي يجوز لـ OpenRouter إرسال رسائل المصادر إليها.",
  "ai.noTraining": "فقط المزوّدون الذين لا يدرّبون نماذجهم على الطلبات",
  "ai.noTrainingHint": "قد تحتوي رسائل المصادر على أسماء أشخاص. أبقِ هذا الخيار مفعّلاً.",
  "ai.providerFallbacks": "السماح لـ OpenRouter بتجربة مزوّدين آخرين للنموذج نفسه",
  "ai.providerFallbacksHint": "يُبقي الدورات مستمرة حين يتعطل أحد مستضيفي النموذج.",
  "ai.sortBy": "تفضيل المزوّدين حسب",
  "ai.sortDefault": "التوازن الافتراضي في OpenRouter",
  "ai.sortPrice": "السعر الأقل",
  "ai.sortThroughput": "سرعة الإخراج",
  "ai.sortLatency": "أسرع استجابة أولى",
  "ai.providerOrder": "المزوّدون المفضّلون",
  "ai.providerOrderHint": "أسماء المزوّدين مفصولة بفواصل، تُجرَّب أولاً وبهذا الترتيب.",
  "ai.systemPrompt": "التعليمات",
  "ai.systemPromptDescription": "تخبر النموذج أي نوع من المحررين يكون. اكتبها بالعربية.",
  "ai.fixedRules": "قاعدة الكتابة بالعربية وصيغة الرد تُضافان تلقائياً ولا يمكن تعديلهما هنا.",
  "ai.guidelines": "الإرشادات التحريرية",
  "ai.guidelinesDescription":
    "قواعد للحالات الحساسة، قاعدة في كل سطر. يعلّم النموذج أي ملخص تنطبق عليه قاعدة، والملخصات المعلَّمة تنتظر محرراً دائماً.",
  "ai.flaggedThisWeek": "مُعلَّم هذا الأسبوع",
  "ai.guidelineHistory": "النسخ السابقة ({n})",
  "ai.current": "الحالية",
  "ai.noGuidelines": "لا إرشادات.",
  "ai.automation": "الاعتماد والميزانية",
  "ai.automationDescription": "حدّد ما يمكن نشره دون محرر، وكم يحق للذكاء الاصطناعي أن ينفق.",
  "ai.autoApprove": "نشر الملخصات غير المعلَّمة دون مراجعة",
  "ai.autoApproveHint": "تبقى الملخصات المعلَّمة بانتظار محرر. أبقِ هذا معطلاً حتى تثق بالإرشادات.",
  "ai.windowHours": "عدد ساعات كل ملخص",
  "ai.windowHoursHint": "يُستخدم حين لا توجد دورة سابقة يُستكمل منها.",
  "ai.maxMessages": "أقصى عدد رسائل للملخص",
  "ai.maxMessagesHint": "تُبقى الأحدث حين يزيد العدد.",
  "ai.monthlyBudget": "الميزانية الشهرية (دولار)",
  "ai.monthlyBudgetHint": "تتوقف الدورات حين يبلغ الإنفاق هذا الحد. الصفر يعني بلا حد.",
  "ai.budgetAlert": "التنبيه عند (٪ من الميزانية)",
  "ai.budgetAlertHint": "يُرسل تنبيهاً مرة في الشهر حين يتجاوز الإنفاق هذه النسبة.",
  "ai.lowCredit": "التنبيه حين ينخفض الرصيد عن (دولار)",
  "ai.lowCreditHint": "يُفحص كل ساعة.",
  "ai.usage": "الإنفاق",
  "ai.usageDescription": "تكلفة كل دورة خلال آخر ٣٠ يوماً، بما فيها التجارب.",
  "ai.spentThisMonth": "المُنفق هذا الشهر",
  "ai.budgetUsed": "نسبة المستخدم من الميزانية الشهرية",
  "ai.ofBudget": "{pct}٪ من {budget}",
  "ai.noSpendYet": "لا دورات خلال آخر ٣٠ يوماً.",
  "ai.legend": "النماذج",
  "ai.otherModels": "نماذج أخرى",
  "ai.chartLabel": "الإنفاق اليومي على الذكاء الاصطناعي خلال آخر {days} يوماً، موزعاً حسب النموذج",
  "ai.total": "المجموع",
  "ai.byModel": "الإنفاق حسب النموذج",
  "ai.runs": "الدورات",
  "ai.tokensInOut": "الرموز الداخلة / الخارجة",
  "ai.cost": "التكلفة",
  "ai.test": "تجربة",
  "ai.testDescription":
    "يلخّص آخر ٣ ساعات بالإعدادات المحفوظة. لا يُنشر شيء، لكن التجربة تستهلك من الرصيد.",
  "ai.testButton": "جرّب على آخر ٣ ساعات",
  "ai.testUsesSaved": "احفظ تغييراتك أولاً، فالتجربة تستخدم الإعدادات المحفوظة.",
  "ai.testEmpty": "لم تصل رسائل خلال آخر ٣ ساعات.",
  "ai.wouldBeFlagged": "سيُعلَّم",
  "ai.tokensShort": "{a} داخلة، {b} خارجة",
  "ai.messagesUsed": "الرسائل: {n}",
  "ai.unsaved": "تغييرات غير محفوظة: {n}",
  "ai.saveVersion": "حفظ كنسخة جديدة",
  "ai.saved": "حُفظت. الدورات الجديدة تستخدم هذه الإعدادات.",

  "schedules.title": "الجداول الزمنية",
  "schedules.description": "متى تعمل كل مهمة. تسري التغييرات خلال دقيقة دون إعادة تشغيل.",
  "schedules.add": "إضافة جدول",
  "schedules.emptyTitle": "لا جداول",
  "schedules.emptyBody": "بلا جداول لا يعمل شيء تلقائياً. أضف جدولاً للتلخيص كل ٣ ساعات.",
  "schedules.name": "الاسم",
  "schedules.job": "المهمة",
  "schedules.when": "التوقيت",
  "schedules.atTimes": "في أوقات محددة",
  "schedules.everyN": "كل بضع دقائق",
  "schedules.cron": "تعبير cron",
  "schedules.cronHint": "الدقيقة الساعة اليوم الشهر يوم-الأسبوع، مثل 0 */3 * * *",
  "schedules.minutes": "الدقائق بين كل تشغيل",
  "schedules.hours": "عدد الساعات المشمولة",
  "schedules.hoursHint": "اتركه فارغاً للاستكمال من الدورة السابقة.",
  "schedules.enabled": "مفعّل",
  "schedules.lastRun": "آخر تشغيل",
  "schedules.runs": "مرات التشغيل",
  "schedules.never": "لم يعمل بعد",
  "schedules.runNow": "تشغيل الآن",
  "schedules.edit": "تعديل الجدول",
  "schedules.delete": "حذف الجدول",
  "schedules.deleted": "حُذف الجدول.",
  "schedules.started": "بدأ تشغيل {name}.",
  "schedules.editTitle": "تعديل الجدول",
  "schedules.newTitle": "جدول جديد",
  "schedules.save": "حفظ الجدول",
  "schedules.saved": "حُفظ الجدول.",
  "schedules.timezoneNote": "الأوقات بتوقيت دمشق.",
  "schedule.kind.summarize": "تلخيص النافذة الأخيرة",
  "schedule.kind.digest": "كتابة الحصاد اليومي",
  "schedule.kind.publish": "نشر الملخصات المعتمدة",
  "schedule.kind.catalog_sync": "تحديث النماذج وفحص الرصيد",
  "schedule.kind.backfill": "جلب منشورات تيليغرام الفائتة",
  "schedule.kind.listener_health": "فحص مستمع تيليغرام",
  "schedule.kind.alert_digest": "إرسال ملخص التنبيهات بالبريد",

  "cron.everyNHours": "كل {n} ساعات، على رأس الساعة",
  "cron.everyNHoursAt": "كل {n} ساعات عند الدقيقة {m}",
  "cron.hourlyAt": "كل ساعة عند الدقيقة {m}",
  "cron.dailyAt": "يومياً الساعة {time}",
  "cron.dailyAtList": "يومياً في {times}",
  "cron.everyNMinutes": "كل {n} دقيقة",

  "platforms.title": "منصات النشر",
  "platforms.description":
    "حيث تُنشر الملخصات المعتمدة. تُحفظ بيانات الدخول مشفّرة ولا يظهر منها إلا آخر الأحرف.",
  "platforms.manual": "يدوي",
  "platforms.configured": "جاهزة",
  "platforms.notConfigured": "تحتاج إعداداً",
  "platforms.testPassed": "الاتصال يعمل",
  "platforms.testFailed": "فشل الاتصال",
  "platforms.noPosts": "لا منشورات بعد",
  "platforms.enabled": "النشر هنا",
  "platforms.enabledToast": "فُعّل النشر على {name}.",
  "platforms.disabledToast": "أُوقف النشر على {name}.",
  "platforms.storedSecret": "محفوظ: {masked}. اتركه فارغاً للإبقاء عليه.",
  "platforms.keepCurrent": "اتركه فارغاً للإبقاء على القيمة المحفوظة",
  "platforms.save": "حفظ الإعدادات",
  "platforms.saved": "حُفظت إعدادات {name}.",
  "platforms.test": "اختبار الاتصال",
  "platforms.lastTest": "آخر اختبار للاتصال",
  "platforms.lastError": "آخر خطأ",
  "platforms.instagramNote":
    "يحمّل إنستغرام الصورة من رابطها، لذا يجب حفظ الصور على تخزين عام عبر HTTPS (مثل S3 أو R2 أو MinIO خلف نطاق).",
  "platforms.xNote": "النشر يتطلب اشتراكاً مدفوعاً في واجهة إكس، ويبقى معطلاً حتى تفعّله.",
  "platforms.whatsappNote": "لا يمكن النشر في قنوات واتساب تلقائياً.",
  "platforms.openExport": "فتح صفحة النسخ واللصق",

  "log.title": "سجل النشر",
  "log.description": "كل محاولة نشر على كل منصة. يُعاد تلقائياً ما يفشل حتى ٥ مرات.",
  "log.tabJobs": "كل المنشورات",
  "log.tabWhatsapp": "تصدير واتساب",
  "log.view": "عرض",
  "log.statusFilter": "التصفية حسب الحالة",
  "log.all": "الكل",
  "log.platform": "المنصة",
  "log.allPlatforms": "كل المنصات",
  "log.summary": "الملخص",
  "log.status": "الحالة",
  "log.attempts": "المحاولات",
  "log.updated": "آخر تحديث",
  "log.retry": "إعادة المحاولة",
  "log.retrying": "جارٍ إعادة المحاولة.",
  "log.emptyTitle": "لم يُنشر شيء بعد",
  "log.emptyBody": "تظهر المنشورات هنا بعد اعتماد ملخص وتفعيل منصة.",
  "log.whatsappIntro": "انسخ كل ملخص معتمد إلى قناة واتساب مع صورته المربعة، ثم علّمه منشوراً.",
  "log.period": "المدة",
  "log.today": "آخر ٢٤ ساعة",
  "log.threeDays": "٣ أيام",
  "log.week": "٧ أيام",
  "log.copyAll": "نسخ الكل",
  "log.copyText": "نسخ النص",
  "log.copied": "نُسخ",
  "log.downloadImage": "الصورة",
  "log.markPosted": "تعليم كمنشور",
  "log.markedPosted": "عُلّم كمنشور.",
  "log.whatsappEmptyTitle": "لا شيء للنشر",
  "log.whatsappEmptyBody": "تظهر هنا الملخصات المعتمدة خلال هذه المدة.",

  "pager.status": "الصفحة {page} من {pages}",
  "pager.previous": "السابق",
  "pager.next": "التالي",

  "notifications.title": "التنبيهات",
  "notifications.description":
    "راسل المالك بالبريد حين تتوقف الملخصات: مشكلات OpenRouter، أو حدود الميزانية، أو انقطاع المستمع، أو فشل النشر.",
  "notifications.notConfiguredTitle": "رسائل التنبيه غير مُعدّة",
  "notifications.notConfiguredBody":
    "تُسجَّل التنبيهات أدناه لكن لا يُراسَل أحد. املأ بيانات خادم البريد والمستلمين.",
  "notifications.email": "خادم البريد",
  "notifications.emailDescription":
    "أي خدمة SMTP تصلح: مزوّد بريدك، أو Amazon SES، أو Mailgun، أو Postmark.",
  "notifications.enabled": "إرسال رسائل التنبيه",
  "notifications.enabledHint": "حين يكون معطلاً تظهر التنبيهات في السجل أدناه فقط.",
  "notifications.host": "خادم SMTP",
  "notifications.port": "المنفذ",
  "notifications.security": "التشفير",
  "notifications.starttls": "STARTTLS (587)",
  "notifications.ssl": "SSL (465)",
  "notifications.noEncryption": "بلا تشفير",
  "notifications.username": "اسم المستخدم",
  "notifications.password": "كلمة المرور",
  "notifications.passwordStored": "محفوظة: {masked}. اتركها فارغة للإبقاء عليها.",
  "notifications.from": "عنوان المُرسِل",
  "notifications.recipients": "إرسال التنبيهات إلى",
  "notifications.recipientsHint": "عنوان واحد في كل سطر.",
  "notifications.testTo": "إرسال التجربة إلى",
  "notifications.sendTest": "إرسال رسالة تجريبية",
  "notifications.testSent": "أُرسلت الرسالة التجريبية",
  "notifications.testFailed": "رفض خادم البريد الرسالة التجريبية",
  "notifications.testNote": "التجربة تستخدم الإعدادات المحفوظة. احفظ أولاً إن غيّرت شيئاً.",
  "notifications.events": "ما يُراسَل بشأنه",
  "notifications.eventsDescription":
    "تُحجب تكرارات المشكلة نفسها خلال فترة التهدئة كي لا يمتلئ بريدك.",
  "notifications.cooldown": "فترة التهدئة (دقائق)",
  "notifications.cooldownHint": "أقل فاصل بين رسالتين عن المشكلة نفسها.",
  "notifications.digest": "جمع التحذيرات في رسالة يومية واحدة",
  "notifications.digestHint": "التنبيهات الحرجة تُرسل فوراً. حدّد الوقت من صفحة الجداول الزمنية.",
  "notifications.save": "حفظ إعدادات التنبيه",
  "notifications.saved": "حُفظت إعدادات التنبيه.",
  "notifications.history": "سجل التنبيهات",
  "notifications.historyDescription":
    "كل تنبيه صدر، أُرسل بالبريد أم لا. افتح أياً منها لرؤية الرسالة كاملة.",
  "notifications.markAllSeen": "تعليم الكل كمقروء",
  "notifications.severity": "الخطورة",
  "notifications.noAlertsTitle": "لا تنبيهات",
  "notifications.noAlertsBody": "تظهر هنا مشكلات الملخصات أو المستمع أو النشر.",
  "notifications.emailed": "أُرسل بالبريد",
  "notifications.emailFailed": "فشل الإرسال",
  "notifications.suppressedCooldown": "حُجب خلال التهدئة",
  "notifications.suppressedDisabled": "لم يُرسل، النوع معطل",
  "notifications.suppressedEmailOff": "لم يُرسل، البريد معطل",
  "notifications.heldForDigest": "بانتظار الرسالة اليومية",
  "notifications.inDigest": "أُرسل في الرسالة اليومية",
  "notifications.sending": "جارٍ الإرسال",

  "event.openrouter_outage": "تعذّر الوصول إلى OpenRouter",
  "event.openrouter_outage.hint": "أخطاء خادم أو انتهاء مهلة بعد كل المحاولات والبدائل.",
  "event.openrouter_auth": "OpenRouter يرفض المفتاح",
  "event.openrouter_auth.hint": "أُلغي المفتاح أو كُتب خطأً أو غير موجود.",
  "event.openrouter_credits": "الرصيد منخفض أو نفد",
  "event.openrouter_credits.hint": "الرصيد دون الحد الذي حددته، أو رفض OpenRouter دورة لعدم الدفع.",
  "event.budget_exceeded": "بلغ الإنفاق الميزانية الشهرية",
  "event.budget_exceeded.hint": "تُتخطى الدورات حتى الشهر القادم أو حتى ترفع الميزانية.",
  "event.model_unavailable": "أُزيل نموذج مختار",
  "event.model_unavailable.hint": "اختفى النموذج الأساسي أو أحد البدائل من OpenRouter.",
  "event.invalid_output": "رد النموذج غير صالح",
  "event.invalid_output.hint": "صيغة خاطئة مرتين متتاليتين، ففشلت الدورة.",
  "event.listener_disconnected": "توقف مستمع تيليغرام",
  "event.listener_disconnected.hint": "لا إشارة من المستمع، أو خرج أحد الحسابات.",
  "event.publish_failed": "فشل منشور",
  "event.publish_failed.hint": "رفضت منصة المنشور بعد كل المحاولات.",
};
